<template>
  <div class="content">
    <div class="base-search">
      <el-input
        placeholder="请输入项目名称"
        v-model="projectName"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
        style="width: 220px;"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <el-input
        placeholder="请输入企业名称"
        v-model="enterprisesHistoryName"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
        style="width: 220px;margin-left: 20px;"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <el-input
        placeholder="请输入组织机构代码"
        v-model="organizationCode"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
        style="width: 230px;margin-left: 20px;"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <el-cascader
        :options="addroptions"
        v-model="area"
        placeholder="请选择所在地区"
        clearable
        @clear="search"
        @change="search"
        style="width: 220px;margin-left: 20px;"
      ></el-cascader>
      <!-- <el-select
        v-model="productTypeId"
        clearable
        placeholder="请选择产品类型"
        style="width: 220px;margin-left: 20px;"
      >
        <el-option
          v-for="item in typeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select> -->
      <el-select
        v-model="investmentFirmsId"
        filterable
        clearable
        remote
        :remote-method="getInvestmentFirms"
        placeholder="请输入贷款银行"
        @change="search"
        style="width: 220px;margin-left: 20px;"
      >
        <el-option
          v-for="(item, index) in investmentFirmsOptions"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="servicesApprovalStatus"
        clearable
        placeholder="请选择审核状态"
        @change="search"
        style="width: 220px;margin-left: 20px;"
      >
        <el-option
          v-for="item in checkOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="base-table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
        class="table"
      >
        <el-table-column type="index" width="150" label="序号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="金融产品名称" align="center" prop="name"></el-table-column>
        <el-table-column
          label="金融产品类型"
          align="center"
          prop="productTypeName"
        ></el-table-column>
        <el-table-column
          label="贷款银行"
          align="center"
          prop="investmentFirmsName"
        ></el-table-column>
        <el-table-column label="项目名称" align="center" prop="projectName"></el-table-column>
        <el-table-column
          label="企业名称"
          align="center"
          prop="enterprisesHistoryName"
        ></el-table-column>
        <el-table-column
          label="组织机构代码"
          align="center"
          prop="organizationCode"
        ></el-table-column>
        <el-table-column label="所在地区" align="center" prop="location">
          <!-- <template slot-scope="scope">
            <span>{{ getArea(scope.row.location) }}</span>
          </template> -->
        </el-table-column>
        <el-table-column label="审核人" align="center" prop="reviewer"></el-table-column>
        <el-table-column label="审核意见" align="center" prop="auditOpinion"></el-table-column>
        <el-table-column label="审核时间" align="center" prop="reviewTime"></el-table-column>
        <el-table-column label="审核状态" align="center" prop="servicesApprovalStatus">
          <template slot-scope="scope">
            <span>{{ getServicesApprovalStatus(scope.row.servicesApprovalStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="机构审核状态" align="center">
          <template slot-scope="scope">
            <span>{{ getInstitutionsApprovalStatus(scope.row.institutionsApprovalStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column width="200px" align="center" label="操作">
          <template slot-scope="scope">
            <el-button class="mini_btn" type="text" @click="handleDetail(scope.row)">
              详情
            </el-button>
            <template v-if="scope.row.servicesApprovalStatus === 1">
              <el-button class="mini_btn" type="text" @click="handleCheck(scope.row, 4)">
                推荐
              </el-button>
              <el-button class="mini_btn" type="text" @click="handleCheck(scope.row, 2)">
                不推荐
              </el-button>
              <el-button class="mini_btn" type="text" @click="handleCheck(scope.row, 3)">
                退回
              </el-button>
            </template>
            <template
              v-if="
                scope.row.institutionsApprovalStatus === 4 && scope.row.servicesApprovalStatus === 4
              "
            >
              <el-button class="mini_btn" type="text" @click="handleCheck(scope.row, 6)">
                不立项
              </el-button>
              <el-button class="mini_btn" type="text" @click="handleCheck(scope.row, 5)">
                立项
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="current_page"
      :page-size="per_page"
      layout="total,prev, pager, next"
      :total="total"
      style="text-align:left;margin:20px 0"
    ></el-pagination>

    <el-dialog
      @closed="is_submit = true"
      :title="Title"
      center
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      class="site.dialog"
      :append-to-body="true"
    >
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="140px">
        <div class="form-title">产品信息</div>
        <el-row>
          <el-row>
            <el-form-item label="产品名称" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入产品名称" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="金融产品类型" prop="productTypeName">
              <el-input v-model="ruleForm.productTypeName" placeholder="请输入金融产品类型" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="ruleForm.projectName" placeholder="请输入项目名称" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="企业名称" prop="enterprisesHistoryName">
              <el-input v-model="ruleForm.enterprisesHistoryName" placeholder="请输入企业名称" disabled></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="所在地区" prop="location">
                <el-input v-model="ruleForm.location" placeholder="请输入所在地区" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <div class="form-title">企业信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="企业名称" prop="enterpriseName">
              <el-input v-model="ruleForm.enterpriseName" placeholder="请输入企业名称" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组织机构代码" prop="organizationCode">
              <el-input
                  v-model="ruleForm.organizationCode"
                  placeholder="请输入组织机构代码"
                  disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业法人" prop="legalPerson">
              <el-input v-model="ruleForm.legalPerson" placeholder="请输入企业法人" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="legalPersonPhone">
              <el-input v-model="ruleForm.legalPersonPhone" placeholder="请输入联系方式" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="财务负责人" prop="financialLeader">
              <el-input v-model="ruleForm.financialLeader" placeholder="请输入联系方式" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="financialLeaderPhone">
              <el-input v-model="ruleForm.financialLeaderPhone" placeholder="请输入联系方式" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input v-model="ruleForm.contactPerson" placeholder="请输入联系人" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="contactPersonPhone">
              <el-input v-model="ruleForm.contactPersonPhone" placeholder="请输入联系方式" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成立时间" prop="establishDate">
              <el-input v-model="ruleForm.establishDate" placeholder="请输入成立时间" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纳税地点" prop="taxLocation">
              <el-input v-model="ruleForm.taxLocation" placeholder="请输入纳税地点" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="注册地址" prop="registeredAddress">
              <el-input v-model="ruleForm.registeredAddress" placeholder="请输入注册地址" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="实际地址" prop="physicalAddress">
              <el-input v-model="ruleForm.physicalAddress" placeholder="请输入实际地址" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="主要经营产品" prop="mainProduct">
              <el-input
                  v-model="ruleForm.mainProduct"
                  placeholder="请填写主要经营产品"
                  disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上年度末总资产" prop="lastYearTotalAssets">
              <el-input
                  v-model="ruleForm.lastYearTotalAssets"
                  placeholder="请填写上年度末总资产"
                  disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上年度销售收入" prop="lastYearSalesRevenue">
              <el-input
                  v-model="ruleForm.lastYearSalesRevenue"
                  placeholder="请填写上年度销售收入"
                  disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="20">
          <el-col :span="12">
            <el-form-item label="自主知识产权数量" prop="independentRightCount" label-width="140px">
              <el-input v-model="ruleForm.independentRightCount" placeholder="请填写自主知识产权数量" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="20">
          <el-col :span="24">
            <el-form-item label-width="125px" label="公司简介" prop="introduction">
              <el-input
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 6 }"
                  placeholder=" 请填写公司简介"
                  v-model="ruleForm.introduction"
                  disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-title">审核信息</div>
        <!-- 审核信息开始 -->
        <el-row :span="20">
          <el-col :span="24">
            <el-form-item label="审核状态" prop="approvalStatus">
              <el-select v-model="ruleForm.approvalStatus" placeholder="请选择审核状态" :disabled="disabled">
                <el-option label="待审核" :value="1"></el-option>
                <el-option label="不通过" :value="2"></el-option>
                <el-option label="退回" :value="3"></el-option>
                <el-option label="通过" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审核意见" prop="auditOpinion">
              <el-input v-model="ruleForm.auditOpinion" placeholder="请填写审核意见" :disabled="disabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="20">
          <el-col :span="24">
            <el-form-item label="附件上传" prop="fileList">
              <el-upload class="upload-demo" :action="this.uploadURL" style="text-align: left;" :before-upload="beforeAvatarUpload" :disabled="disabled"
                         :on-remove="(file, fileList)=>handleRemove(file, fileList,'fileList')" :file-list="fileList" :on-success="(response, file, fileList) => handleAvatarSuccess(response, file, fileList,'fileList')"
                         list-type="picture">
                <el-button size="small" type="primary" :disabled="disabled">上传附件材料</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog
      title="审批内容"
      center
      :visible.sync="dialogCheckVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form
        label-position="right"
        ref="form"
        size="small"
        :model="recordForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="审核意见" prop="introduction">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="请输入审核意见"
            v-model="recordForm.auditOpinion"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <el-upload
            class="upload-demo"
            :action="this.uploadURL"
            name="file"
            :file-list="fileList"
            :show-file-list="true"
            :on-remove="onRemove"
            :on-success="handlePictureCardPreview"
            :on-preview="onPreview"
            accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm()">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { FunDownload } from "@/utils/tool";
import CompanyDetail from './companyDetail.vue';
import { regionData, CodeToText } from 'element-china-area-data';

export default {
	components: {
    CompanyDetail
	},
	data() {
		return {
			is_submit: true,
			total: 10,
			per_page: 10,
			current_page: 1,
			Title: "",
			projectName: null,
      enterprisesHistoryName: null,
      organizationCode: null,
      area: null,
      investmentFirmsId: null,
      servicesApprovalStatus: null,
			dialogFormVisible: false,
			deleteRow: "",
			fileList: [],
			tableData: [],
			checkOptions: [{
					value: 1,
					label: "未审核",
				},
        {
					value: 2,
					label: "不推荐",
				},
        {
					value: 3,
					label: "已退回",
				},
				{
					value: 4,
					label: "已推荐",
				},
        {
					value: 5,
					label: "已立项",
				},
        {
					value: 6,
					label: "不立项",
				},
			],
			typeOptions: [{
					value: "001",
					label: "股票",
				},
				{
					value: "002",
					label: "债券",
				},
				{
					value: "003",
					label: "期权",
				},
				{
					value: "004",
					label: "认股证",
				},
				{
					value: "005",
					label: "国库券",
				},
				{
					value: "006",
					label: "银行信贷产品",
				}
			],
			ruleForm: {},
			recordForm: {
				productApplyId: null, // 金融产品申请表id
				auditOpinion: null, // 审核意见
				approvalStatus: null // 审核状态
			},
      rules: {
        image: [{ required: true, trigger: 'blur', message: '请上传头像' }]
      },
      dialogCheckVisible: false,
      addroptions: regionData,
      investmentFirmsOptions: []
		};
	},
	created() {
		this.search();
	},
	methods: {
    getArea(value) {
      if (value && typeof value === 'string') {
        value = JSON.parse(value);
        return this.getAreaText(value);
      } else if (value) {
        return this.getAreaText(value);
      }
      return '';
    },
    getAreaText(value) {
      return CodeToText[value[0]] + ' ' + CodeToText[value[1]] + ' ' + CodeToText[value[2]];
    },
		getServicesApprovalStatus(status) {
      const item = this.checkOptions.find((detail) => detail.value === status);
      if(item) {
        return item.label
      }
			return ''
		},
		getInstitutionsApprovalStatus(status) {
			switch (status) {
				case 1:
					return '待审核'
				case 2:
					return '不通过'
				case 3:
					return '退回'
				case 4:
					return '通过'
			}
		},
		getData(item) {
			const params = {
				page: this.current_page,
				pageSize: this.per_page,
				...item,
			}
      params.organizationCode = params.organizationCode || null
      params.location = params.location || null
			this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/product-apply/page`, params).then((res) => {
        if (res.code == 0) {
					this.tableData = res.data.data;
					this.total = res.data.total;
					this.per_page = res.data.per_page;
					this.current_page = res.data.current_page * 1;
				}
			});
		},
		//搜索
		search() {
      let area = null;
      if(this.area) {
        area = CodeToText[this.area[2]];
        if(area === '市辖区') {
          area = CodeToText[this.area[1]];
        }
      }
			this.getData({
        page: 1,
				projectName: this.projectName,
        organizationCode: this.organizationCode,
        enterprisesHistoryName: this.enterprisesHistoryName,
        location: area,
        investmentFirmsId: this.investmentFirmsId,
        servicesApprovalStatus: this.servicesApprovalStatus
			});
		},
		//选择
		selectionChange(selection) {
			this.deleteRow = "";
			if (selection.length != 0) {
				let arr = [];
				selection.forEach((item) => {
					arr.push(item.id);
				});
				this.deleteRow = arr.join(",");
			}
		},
		//编辑
		handleDetail(row) {
			this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/finance/product-apply/get?id=${row.id}`)
        .then((res) => {
          if (res.code == 0) {
            const data = res.data;
            this.ruleForm = data;
            this.fileList = res.data.fileList ? JSON.parse(res.data.fileList) : []
            this.ruleForm.registeredAddress = this.ruleForm.registeredAddress ? JSON.parse(this.ruleForm.registeredAddress).join(' - ') + ' - ' + this.ruleForm.registeredAddressDetail : ""
            this.ruleForm.physicalAddress = this.ruleForm.physicalAddress ? JSON.parse(this.ruleForm.physicalAddress).join(' - ') + ' - ' + this.ruleForm.physicalAddressDetail : ""
						this.dialogFormVisible = true;
						this.Title = "详情";
          } else {
            this.$message({
              message: "失败！",
              type: "error",
            });
          }
        });

		},
    // 审核
    handleCheck(item, type) {
      if (type === 5 && type === 6) {
        this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/product-apply/projectApproval`, {
          id: item.id,
          servicesApprovalStatus: type
        }).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "提交成功",
            });
            this.search();
          }
        });
      } else {
        this.recordForm.productApplyId = item.id
        this.recordForm.approvalStatus = type;
        this.recordForm.servicesApprovalStatus = type;
        this.dialogCheckVisible = true
      }
    },

		//翻页
		handleCurrentChange(e) {
      let area = null;
      if(this.area) {
        area = CodeToText[this.area[2]];
        if(area === '市辖区') {
          area = CodeToText[this.area[1]];
        }
      }
			this.getData({
        page: e,
				projectName: this.projectName,
        organizationCode: this.organizationCode,
        location: area,
        investmentFirmsId: this.investmentFirmsId,
        servicesApprovalStatus: this.servicesApprovalStatus
			});
		},
		//取消
		closeForm() {
			this.dialogCheckVisible = false;
		},
		//提交
		submitForm() {
			const params = {
				...this.recordForm,
				fileList: this.fileList.length > 0 ? JSON.stringify(this.fileList) : ''
			}
			this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/product-apply-record/approval`, params).then((res) => {
				if (res.code == 0) {
					this.$message({
            type: "success",
            message: "提交成功",
          });
          this.dialogCheckVisible = false;
          this.search();
				}
			});
		},
    getInvestmentFirms(val) {
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/getList`, {
        is_page: 1,
        keyword: val,
        dataType: 2
      }).then((res) => {
				if (res.code == 0) {
					this.investmentFirmsOptions = res.data.map((item) => {
            return {
              label: item.orgName,
              value: item.id
            }
          })
				}
			});
    },
		onRemove(file, fileList) {
      this.fileList = this.getList(fileList);
    },
    handlePictureCardPreview(response, file, fileList) {
      this.fileList = this.getList(fileList);
    },
    onPreview(file) {
      FunDownload(this.imgUrl + file.url, file.name);
    },
    getList(fileList) {
      return fileList.map((el) => {
        return {
          name: el.name,
          url: el?.url || el?.response?.data.store_result,
          uid: el.uid,
        };
      });
    },
	},
};
</script>

<style scoped lang="scss">
.content {
  height: 100%;
  width: 100%;
  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
  /deep/ .upload-demo {
    border: 1px solid #ffffff !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
.form {
  /deep/ {
    .el-input,
    .el-select,
    .el-cascader {
      width: 100%;
    }
  }
}
/deep/ .upload-demo {
  border: none !important;
}
</style>
